<template>
  <v-autocomplete
    v-model="computedValue"
    v-bind="{ noDataText: $i18n.t('default.noData'), menuProps: { offsetY: true }, ...$attrs }"
    v-on="$listeners"
    class="font-size-14"
  >
    <template v-for="(value, key) in $scopedSlots" #[key]="scope">
      <slot :name="key" v-bind="scope" />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'DataInputAutocomplete',
  props: {
    value: {
      default: null,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-select.v-text-field input,
::v-deep .v-list-item__content .v-list-item__title {
  color: map-get($colors, 'font-lighten-1');
}
::v-deep .v-input__append-inner {
  margin-top: 8px !important;
}
</style>
